import { useEffect, useState } from 'react';
import ErulesViewer from './ErulesViewer';

function EasyAccess() {
    const [ear, setEar] = useState({});

    useEffect(() => {
        fetch('/data/ear_caw-2.json')
            .then((response) => response.json())
            .then((data) => setEar(data))
            .catch((error) => console.error('Error fetching data:', error));
    }, []);

    console.log(ear.document[1]['doc-content'][0].toc);

    return (
        <section className="easy-access">
            <div className="easy-access__container">
                <h2 className="easy-access__title">Easy Access</h2>
                <p className="easy-access__text">
                    Our platform is designed for easy access, allowing you to manage your compliance needs from anywhere, at any time.
                    Whether you're in the office or on the go, our user-friendly interface ensures you can quickly find the information you
                    need.
                </p>
                <ErulesViewer data={ear.document[1]['doc-content'][0].toc[13]} />  
                <div>
                    {/* <p>
                        {ear && ear.document[1]['doc-content'][0]['toc'].map((x) => (
                            <p>{x.heading}</p>
                        ))}
                    </p> */}
                    {/* <p>{ear['er:document']['er:toc']['er:topic'].map((x,i) => (

                <p key={i}>{Object.keys(x)}</p>
            
            )
            )}</p> */}
                </div>
            </div>
        </section>
    );
}

export default EasyAccess;
